/**
 * Included into the footer of pages.
 */

import * as variables from './variables';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});



//===================================================================
// FAQ's
//===================================================================
const availableAccordion = $(".faqs");

if(availableAccordion.length !== 0) {
	// On Page Load - Close all accoridons
	const firstAccordionActive = availableAccordion.find('.faqs__item');
	for (let i = 0; i < firstAccordionActive.length; i++) {
		$(firstAccordionActive[i]).removeClass("active").find(".answer").slideUp(0);
	}

	// Listeners
	$('.faqs__items .question').on( "click" , function( event ) {
		const questionId = $(this).parent().attr('data-question-id');
		availableAccordion.trigger("changeActive", {questionId});
	});

	// Triggers
	// Updates 'Active' Accordion
	availableAccordion.on( "changeActive" , function(event, data) {
		const updateActiveAccordion = availableAccordion.find(".faqs__item");

		for (let i = 0; i < updateActiveAccordion.length; i++) {
			if (data.questionId === updateActiveAccordion[i].dataset.questionId) {
				if ($(updateActiveAccordion[i]).hasClass("active")) {
					$(updateActiveAccordion[i]).removeClass("active").find(".answer").slideUp();
				} else {
					$(updateActiveAccordion[i]).addClass("active").find(".answer").slideDown();
				}
			} else {
				// To have only one accordion open at a time, uncomment the line below.
				// $(updateActiveAccordion[i]).removeClass("active").find(".answer").slideUp();
			}
		}
	});
}
//===================================================================



// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .pageFooter__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .pageFooter__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //
